import $ from "jquery";

class HotspotPreview {

    constructor(data) {
        this.path = []
        this.route = []
        this.frames = []
        this.window = []
        this.windowFrames = []

        this.id = "hotspot-" + data.id
        this.currentFrame = null

        this.data = data

        this.parent = $('#hotspot-editor-preview')

        this.style = null
        this.spot = null
        this.content = null
        this.videoIframe = null

        this.imageObj = null

        this.buildHTML()
        this.bind()

        // set when editing the position
        this.isActive = false

        // set when spot is dragged
        this.mouseDrag = false

        // set to false when another hotspot is edited
        this.isVisible = true

        // tracking editor updates
        this.dirty = false

        this.parse()
    }

    buildHTML() {
        if (this.spot === null) {
            this.style = $('<style></style>').appendTo($('head'))
            this.spot = $('<div class="hotspot-spot"></div>').attr("id", this.id).appendTo(this.parent)
            this.content = $('<div class="hotspot-content"></div>').appendTo(this.parent)
            this.wrapper = $('<div class="hotspot-content-default"></div>').appendTo(this.content)
            this.contentClose = $('<span class="hotspot-content-close">&times;</span>').appendTo(this.content)
            this.contentText = $('<div></div>').appendTo(this.wrapper)
            this.contentImage = $('<div></div>').appendTo(this.wrapper)
            this.contentVideo = $('<div></div>').appendTo(this.wrapper)
        }

        this.style.html(`#${this.id}:before { background-color: ${this.data.color}; } #${this.id}:after { border-color: ${this.data.color}; }`)

        // SPOT
        if (this.data.shadow === true) {
            this.spot.addClass('spot-shadow')
        } else {
            this.spot.removeClass('spot-shadow')
        }

        // CONTENT

        let maxHeight = this.parent.height() - 100
        this.content.css({ maxHeight: maxHeight + 'px' })

        let position = this.data.content_position || 'tl'
        this.content.attr('class', 'hotspot-content hotspot-content-' + position);

        // WRAPPER
        this.wrapper.attr('style', '')

        if (this.data.content_mode === 'custom') {
            this.wrapper.attr('class', 'hotspot-content-custom')
            this.contentText.html(this.data.text)
        } else {
            this.wrapper.attr('class', 'hotspot-content-default')

            if (this.data.font_family) {
                this.wrapper.css({ fontFamily: this.data.font_family })
            }
            if (this.data.content_foreground) {
                this.wrapper.css({ color: this.data.content_foreground })
            }

            if (this.data.content_opacity) {
                this.wrapper.css({ opacity: this.data.content_opacity })
            } else {
                this.wrapper.css({ opacity: '0.95' })
            }

            if (this.data.content_background) {
                this.wrapper.css({ backgroundColor: this.data.content_background })
            } else {
                this.wrapper.css({ backgroundColor: '#fff' })
            }

            this.contentText.html('')
            this.contentVideo.html('')
            this.videoIframe = null

            if (this.data.text) {
                this.contentText.html(this.data.text)
            }

            this.contentImage.html('')
            if (this.imageObj) {
                this.contentImage.get(0).appendChild(this.imageObj)
            } else if (this.data.image_url) {
                let image = $('<img>').attr('src', this.data.image_url)
                this.contentImage.html(image)
            }

            if (this.data.video) {
                let iframe = $('<iframe></iframe>')
                let url = this.data.video
                iframe.attr('src', url)
                //iframe.attr('width', 640)
                //iframe.attr('height', 360)
                iframe.attr('frameBorder', '0')
                iframe.attr('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')
                this.videoIframe = iframe
            }
        }
    }

    remove() {
        this.spot.remove()
        this.style.remove()
        this.content.remove()
    }

    bind() {
        let that = this

        this.spot.bind('click', function (e) {
            // Prevent opening while dragging; allow in non-position tabs
            if (that.mouseDrag) return
            that.showContent()
        })

        this.contentClose.bind('click', function () {
            that.hideContent()
        })
    }

    showContent() {
        if (this.videoIframe) {
            this.contentVideo.html(this.videoIframe)
        }

        this.content.show()
    }

    hideContent() {
        this.content.fadeOut()
        if (this.videoIframe) {
            this.contentVideo.html('')
        }
    }

    parse() {
        let path = this.data.path

        if (path === undefined || path === null || path === '') {
            return
        }

        let numbers = path.split(',').map(x => parseInt(x))
        this.path = []
        for (let i = 0; i < numbers.length; i += 3) {
            this.path.push(numbers.slice(i, i + 3))
        }

        this.window = []
        if (this.data.window) {
            this.window = this.data.window.split(',').map(x => parseInt(x))
        }

        this.calcFrames()
        this.calcWindowFrames()
    }

    setPoint(index, x, y, recalculate = true) {
        // mark dragging during setPoint invoked by drag
        this.mouseDrag = true
        let offset = this.parent.offset()
        let width = this.parent.width()

        x = Math.round((x - offset.left) / width * 1000)
        y = Math.round((y - offset.top) / width * 1000)

        let position = 0
        let replace = false
        let window = false

        if (this.path.length === 0) {
            position = 0
        } else if (this.path.length === 1) {
            let first = this.path[0][0]
            if (index == first) {
                replace = true
            } else if (index > first) {
                if (index - first < this.data.frames / 2) {
                    position = 1
                } else {
                    position = 0
                }
                window = true
            } else {
                if (first - index < this.data.frames / 2) {
                    position = 0
                } else {
                    position = 1
                }
                window = true
            }
        } else {
            let path = this.path.map((wp) => wp[0])

            if (path.indexOf(index) > -1) {
                replace = true
                position = path.indexOf(index)
            } else {
                let insert = false
                for (let i = 0; i < path.length - 1; i++) {
                    if (this.isBetween(path[i], path[i + 1], index)) {
                        insert = true
                        position = i + 1
                        break
                    }
                }

                if (insert === false) {
                    window = true
                    let first = path[0]
                    let last = path[path.length - 1]
                    //console.log(index, first, this.distance(first, index), last, this.distance(last, index))
                    if (this.distance(first, index) < this.distance(last, index)) {

                        position = 0
                    } else {
                        position = path.length
                    }
                }
            }
        }

        if (replace) {
            this.path[position] = [index, x, y]
        } else {
            this.path.splice(position, 0, [index, x, y])
        }

        if (recalculate) {
            this.updatePath()

            if (window) {
                this.window = [this.path[0][0], this.path[this.path.length - 1][0]]
                this.updateWindow()
            }

            this.calcFrames()
        } else {
            if (this.frames.length > index) {
                this.frames[index] = [x, y]
            }
        }
        this.render(this.currentFrame)
        // leave mouseDrag true; it will be cleared after mouseup in editor
    }

    distance(a, b) {
        let d = Math.abs(b - a)
        if (d > this.data.frames / 2) {
            d = this.data.frames - d
        }
        return d
    }

    isBetween(lower, upper, value) {
        for (let i = lower; i !== upper; i++) {
            if (i >= this.data.frames) {
                i = -1
            }
            if (i === value) {
                return true
            }
        }
        return false
    }

    removePoint(index) {
        for (let i = 0; i < this.path.length; i++) {
            if (this.path[i][0] === parseInt(index)) {
                this.path.splice(i, 1)
            }
        }
        this.updatePath()
        this.calcFrames()
    }


    updateWindow() {
        this.data.window = this.window.join(',')
        this.calcWindowFrames()
    }

    calcWindowFrames() {
        this.windowFrames = []
        for (let i = this.window[0]; i !== this.window[1]; i++) {
            if (i >= this.data.frames) {
                i = -1
            }
            this.windowFrames.push(i)
        }
        this.windowFrames.push(this.window[1])

    }

    updatePath() {
        let path = []

        for (let point of this.path) {
            path.push(point[0])
            path.push(point[1])
            path.push(point[2])
        }

        this.data.path = path.join(',')
    }

    clearPath() {
        this.data.path = ''
        this.path = []
        this.route = []
        this.frames = []
        this.window = []
        this.windowFrames = []
        this.render(this.currentFrame)
    }

    render(frame) {
        let point = this.frames[frame]

        // If hotspot is not visible, hide it
        if (!this.isVisible) {
            this.spot.removeClass('pulse')
            return
        }

        // If hotspot is active (being edited) but has no path data, show it in center
        if (this.isActive && (point === null || point === undefined || this.route.length === 0)) {
            this.spot.addClass('pulse')
            let centerX = this.parent.width() / 2
            let centerY = this.parent.height() / 2
            this.spot.css({
                left: centerX + 'px',
                top: centerY + 'px',
            })
            return
        }

        // If hotspot has no valid point data, hide it
        if (point === null || point === undefined) {
            this.spot.removeClass('pulse')
            return
        }

        // If frame is not in window frames or route, hide it
        if (this.windowFrames.indexOf(frame) === -1 && this.route.indexOf(frame) === -1) {
            this.spot.removeClass('pulse')
            return
        }

        this.currentFrame = frame
        this.spot.addClass('pulse')

        let left = point[0] / 1000 * this.parent.width()
        let top = point[1] / 1000 * this.parent.width()

        this.spot.css({
            left: left + 'px',
            top: top + 'px',
        })
    }

    calcFrames() {
        let frames = []
        let route = []

        // initialize frames
        for (let i = 0; i < this.data.frames; i++) {
            frames.push([-1, -1])
        }

        // fill frames with path positions
        for (let point of this.path) {
            route.push(point[0])
            frames[point[0]] = [point[1], point[2]]
        }

        if (route.length === 1) {
            for (let i = 0; i < frames.length; i++) {
                frames[i] = [this.path[0][1], this.path[0][2]]
            }
        } else {
            for (let i = 0; i < route.length; i++) {
                let a = route[i]
                let b = 0, steps = 0

                // get next waypoint
                if (i === route.length - 1) {
                    b = route[0]
                } else {
                    b = route[i + 1]
                }

                // distance between waypoints
                if (b > a) {
                    steps = b - a
                } else {
                    steps = this.data.frames - a + b
                }

                // position change per step
                let dx = (frames[b][0] - frames[a][0]) / steps
                let dy = (frames[b][1] - frames[a][1]) / steps

                for (let j = 1; j < steps; j++) {
                    let index = a + j
                    if (index >= frames.length) {
                        index = index - frames.length
                    }
                    frames[index][0] = Math.round(frames[a][0] + j * dx)
                    frames[index][1] = Math.round(frames[a][1] + j * dy)
                }
            }
        }

        this.frames = frames
        this.route = route
    }
}

// Make HotspotPreview available globally
window.HotspotPreview = HotspotPreview;
